import { Blocks, Zap, Clock, DollarSign } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const NoCodeHeroSection = () => {
  return (
    <section className="pt-24 pb-8 sm:pt-28 sm:pb-10">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Badge variant="outline" className="text-primary border-primary/30 bg-primary/5">
          <Blocks className="w-3 h-3 mr-1" />
          Development
        </Badge>
        <Badge variant="outline" className="text-muted-foreground border-border">9 min read</Badge>
      </div>
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-foreground leading-tight mb-4">
        No-Code vs Traditional Development: <span className="text-primary">When to Use What</span>
      </h1>
      <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-3xl mb-8">
        Understand when to use no-code platforms vs custom development. Learn hybrid approaches that combine speed with flexibility.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Zap className="w-6 h-6 text-primary mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">65%</div>
          <div className="text-sm text-muted-foreground">Faster MVPs</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <DollarSign className="w-6 h-6 text-chart-2 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">$50K+</div>
          <div className="text-sm text-muted-foreground">Avg savings</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Clock className="w-6 h-6 text-chart-4 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">Days</div>
          <div className="text-sm text-muted-foreground">Not months</div>
        </div>
        <div className="bg-card rounded-xl border border-border p-4 text-center">
          <Blocks className="w-6 h-6 text-chart-1 mx-auto mb-2" />
          <div className="text-2xl font-bold text-foreground">Hybrid</div>
          <div className="text-sm text-muted-foreground">Best approach</div>
        </div>
      </div>
    </section>
  );
};
